"use strict";

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abstractmessage_1 = require("./abstractmessage");

var ContinuationTokenStatus = function ContinuationTokenStatus() {
  _classCallCheck(this, ContinuationTokenStatus);
};

exports.ContinuationTokenStatus = ContinuationTokenStatus;

var InitReply =
/*#__PURE__*/
function (_abstractmessage_1$Ab) {
  _inherits(InitReply, _abstractmessage_1$Ab);

  function InitReply(id, continuationToken, continuationTokenStatus, offlineStorage, initRegistrations, debugInfo) {
    var _this;

    _classCallCheck(this, InitReply);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InitReply).call(this, id));
    _this.continuationToken = continuationToken;
    _this.continuationTokenStatus = continuationTokenStatus;
    _this.offlineStorage = offlineStorage;
    _this.initRegistrations = initRegistrations;
    _this.debugInfo = debugInfo;
    return _this;
  }

  return InitReply;
}(abstractmessage_1.AbstractMessage);

exports.InitReply = InitReply;